import { useRequest } from "hooks";
import type { ID, ResourceResponse, ThunkReturnType } from "types";
import { ApiRouteTypes } from "consts/enpoints/api";
import useExportTable from "hooks/useExportTable";
import type { IbanXsBanksCountriesPivot, IbanXsBanksCountriesPivotResponse } from "../types";
import {
    getIbanXsBanksCountriesPivotThunk,
    updateIbanXsBanksCountriesPivotThunk,
    deleteIbanXsBanksCountriesPivotThunk,
    createIbanXsBanksCountriesPivotThunk
} from "../thunks";
import { changeExportIbanXsBanksCountriesPivotLoading as changeExportLoading } from "../slice";

export const useIbanXSBanksCountriesPivotActions = () => {
    const getIbanXSBanksCountriesPivot = useRequest<
        ThunkReturnType<IbanXsBanksCountriesPivotResponse>,
        string | undefined
    >({
        thunk: getIbanXsBanksCountriesPivotThunk
    });

    const createIbanXSBanksCountriesPivot = useRequest<
        ThunkReturnType<ResourceResponse<IbanXsBanksCountriesPivot>>,
        Partial<IbanXsBanksCountriesPivot>
    >({
        thunk: createIbanXsBanksCountriesPivotThunk
    });

    const updateIbanXSBanksCountriesPivot = useRequest<
        ThunkReturnType<ResourceResponse<IbanXsBanksCountriesPivot>>,
        Partial<IbanXsBanksCountriesPivot>
    >({
        thunk: updateIbanXsBanksCountriesPivotThunk
    });

    const deleteIbanXSBanksCountriesPivot = useRequest<
        ThunkReturnType<ResourceResponse<ID>>,
        Pick<IbanXsBanksCountriesPivot, 'coreId'>
    >({
        thunk: deleteIbanXsBanksCountriesPivotThunk
    });

    const downloadCsv = useExportTable({
        changeExportLoading,
        apiResourceType: ApiRouteTypes.GetIbanXsBanksCountriesPivot
    });

    return {
        getIbanXSBanksCountriesPivot,
        createIbanXSBanksCountriesPivot,
        updateIbanXSBanksCountriesPivot,
        deleteIbanXSBanksCountriesPivot,
        downloadCsv
    };
};

export default useIbanXSBanksCountriesPivotActions;
